// Wire keys from backend GET /school-feature-policy/me (backend#2728); never rename the values.
export enum SchoolFeature {
  AI_FEATURES = 'ai_features',
  AI_VOICE_TRANSCRIPTION = 'ai_voice_transcription',
  HEALTH_INTEGRATIONS = 'health_integrations',
  LOCATION_ROUTINES = 'location_routines',
  SESSION_REPLAY = 'session_replay',
  THIRD_PARTY_INTEGRATIONS = 'third_party_integrations',
  SHARED_PROJECT_COMMENTS = 'shared_project_comments'
}
